import React from 'react';
import PropTypes from 'prop-types';

const SvgRectangle = ({ active, ...props }) => {
    const fillColor = active ? '#128383' : '#EAEBF0';
    const strokeColor = active ? '#ffffff' : '#343A72';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26" {...props}>
            <path
                fill={fillColor}
                fillRule="evenodd"
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M24.314 25H1.686A.686.686 0 0 1 1 24.314V1.686C1 1.307 1.307 1 1.686 1h22.628c.38 0 .686.307.686.686v22.628a.686.686 0 0 1-.686.686Z"
                clipRule="evenodd"
            />
        </svg>
    );
};
SvgRectangle.propTypes = {
    active: PropTypes.bool,
};
SvgRectangle.defaultProps = {
    active: false,
};

export default SvgRectangle;
